import React from "react"

import PageBase from "components/Common/PageBase"
import FullSpinner from "components/Common/FullSpinner"

import useAvailabilityCreate from "./useAvailabilityCreate"
import useAvailabilityForm from "common/availability/hooks/useAvailabilityForm"
import { BREADCRUMB_LIST } from "./static"
import AvailabilityFilters from "common/availability/components/AvailabilityFilters"
import ProductTabs from "common/availability/components/ProductTabs"
import AvailabilityForm from "common/availability/components/AvailabilityForm"
import AvailabilityList from "common/availability/components/AvailabilityList"

import "common/availability/availability.css"

const AvailabilityCreateContainer = () => {
  const { state, events } = useAvailabilityCreate()

  // Formulario de alta. Se reinicia al cambiar de sucursal (regions) y, tras
  // un alta correcta, de forma explícita.
  const form = useAvailabilityForm(null, state.regions)

  const onGuardar = async () => {
    if (!state.product || !state.farmId || !state.date) return
    const mensaje = form.validar()
    if (mensaje) {
      form.setError(mensaje)
      return
    }
    const ok = await events.onCreate(
      form.construirRegistro({ farmId: state.farmId, product: state.product })
    )
    if (ok) form.events.reset()
  }

  const puedeAlta = !!(state.product && state.farmId && state.date)

  let claseGuardar = "av-btn-save"
  if (state.isSaving) claseGuardar += " is-saving"
  else if (state.isSaved) claseGuardar += " is-saved"

  let textoGuardar = "Guardar"
  if (state.isSaving) textoGuardar = "Guardando…"
  else if (state.isSaved) textoGuardar = "✓ Guardado"

  return (
    <>
      {state.isLoading && <FullSpinner />}

      <PageBase
        titleMeta="Alta de Disponibilidad"
        titleBread="Alta de Disponibilidad"
        itemsBread={BREADCRUMB_LIST}
      >
        <div className="av-page mt-3">
          <div className="av-head av-anim">
            <div>
              <h1>Alta de Disponibilidad</h1>
              <p>
                Carga la disponibilidad diaria del proveedor: pesos,
                calificaciones, camiones y precios por zona.
              </p>
            </div>
            <button
              type="button"
              className={claseGuardar}
              disabled={!puedeAlta || state.isSaving}
              onClick={onGuardar}
            >
              {textoGuardar}
            </button>
          </div>

          <AvailabilityFilters
            providers={state.providers}
            providerId={state.providerId}
            dates={state.dates}
            date={state.date}
            farms={state.farms}
            farmId={state.farmId}
            onChangeProvider={events.onChangeProvider}
            onChangeDate={events.onChangeDate}
            onChangeFarm={events.onChangeFarm}
          />

          {!state.isLoading && state.products.length === 0 && (
            <div className="av-empty">
              {state.providers.length === 0
                ? "No hay proveedores registrados."
                : state.farms.length === 0
                ? "El proveedor no tiene sucursales registradas."
                : "No hay productos asignados al proveedor."}
            </div>
          )}

          {state.product && (
            <>
              <ProductTabs
                products={state.products}
                tabActive={state.tabActive}
                onChangeTab={events.onChangeTab}
              >
                <div className="av-section-title">
                  <i />
                  <span>Nueva disponibilidad — {state.product.name}</span>
                </div>

                <AvailabilityForm
                  form={form}
                  regions={state.regions}
                  farm={state.farm}
                  onSaveZones={events.onSaveZones}
                />
              </ProductTabs>

              <AvailabilityList
                registradas={state.registradas}
                regions={state.regions}
                farm={state.farm}
                farmId={state.farmId}
                product={state.product}
                expanded={state.expanded}
                editing={state.editing}
                isSaving={state.isSaving}
                onToggleExpanded={events.onToggleExpanded}
                onStartEdit={events.onStartEdit}
                onCancelEdit={events.onCancelEdit}
                onUpdate={events.onUpdate}
                onSaveZones={events.onSaveZones}
              />
            </>
          )}
        </div>
      </PageBase>
    </>
  )
}

export default AvailabilityCreateContainer
